// extracted by mini-css-extract-plugin
export default {"header":"Home_header__6-AUA","card":"Home_card__XRJBU","modalContent":"Home_modalContent__VT7GX"};